import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import OtpForm from "../forms/otpForm";
import DeviceContext from "../../../services/indentifyDevice";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import { IOtpFormProps } from "../forms/otpForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import EdButton from "../../generic/edButton";
import { useEffect } from "react";
import { getTolocalStorage } from "../../../Containers/Constants/commenFeatures";

export interface IOtpScreenProps extends IOtpFormProps {
  onClose?: () => void;
  onSwitchLoginFlow:(flow: string) => void;
}

const OtpScreen: React.FC<IOtpScreenProps> = (props) => {
  const [showSwitch, setShowSwitch] = React.useState(false);
  const [etotpSwitch, setEtotpSwitch] = React.useState(false);
  useEffect(() => {
    async function checkLoginFlow() {
      const loginFlow = await getTolocalStorage("LoginFlow");
      if (loginFlow === "OTP" || loginFlow === "TOTP") {
        setEtotpSwitch(false);
      } else if (loginFlow === "ETOTP" || loginFlow === "BOTH"){
        setEtotpSwitch(true);
      }
    }
    checkLoginFlow();
  }, []);
  
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <OtpForm {...props} />
      {etotpSwitch && (
      <>
        <label className="text-center blue-txt mg-t20 hoverPink" onClick={()=>setShowSwitch(!showSwitch)}>Problem with SMS / email OTP?</label>
        <div className="login_frm_btm_txt text-center mg-b40">
            {showSwitch && <EdButton
            value="ETOTP"
            btnTyp="blue-link"
            className="font-16 pd-t10"
            onClick={() => props.onSwitchLoginFlow("ETOTP")}
            />}
        </div>
      </>)}
    </LoginPopup>
  );
};

export default OtpScreen;
